import eventType from '../@constants/eventType'

export default [
  {label: 'ALIGNER_CHANGE', value: eventType.ALIGNER_CHANGE},
  {label: 'MESSAGE_SENT_TO_DOCTOR', value: eventType.MESSAGE_SENT_TO_DOCTOR},
  {label: 'NEW_MESSAGE', value: eventType.NEW_MESSAGE},
  {label: 'MISSED_ALIGNER_CHANGED_DATE', value: eventType.MISSED_ALIGNER_CHANGED_DATE},
  {label: 'ALIGNER_CHANGE_FEEDBACK_ADDED', value: eventType.ALIGNER_CHANGE_FEEDBACK_ADDED},
  {label: 'TREATMENT_STARTING', value: eventType.TREATMENT_STARTING},
  {label: 'TREATMENT_COMPLETED', value: eventType.TREATMENT_COMPLETED},
  {label: 'PATIENT_CONNECTED_WITH_DOCTOR', value: eventType.PATIENT_CONNECTED_WITH_DOCTOR},
  {label: 'ALIGNER_PRODUCTION_ORDER_REMINDER', value: eventType.ALIGNER_PRODUCTION_ORDER_REMINDER},
  {label: 'UPGRADE_PATIENT_TO_MOBILE_APP', value: eventType.UPGRADE_PATIENT_TO_MOBILE_APP},
  {label: 'RESUME_TREATMENT_REMINDER', value: eventType.RESUME_TREATMENT_REMINDER},
  {label: 'CREATE_REFINEMENT_REMINDER', value: eventType.CREATE_REFINEMENT_REMINDER},
  {label: 'MANUAL_ALIGNER_CHANGE', value: eventType.MANUAL_ALIGNER_CHANGE},
  {label: 'ALIGNER_CHECK_IN_FOR_DOCTOR', value: eventType.ALIGNER_CHECK_IN_FOR_DOCTOR},
  {label: 'ISSUE_REPORTED', value: eventType.ISSUE_REPORTED},
  {label: 'APPOINTMENT_REMINDER', value: eventType.APPOINTMENT_REMINDER},
  {label: 'PAYMENT_REMINDER', value: eventType.PAYMENT_REMINDER},
  {label: 'CALENDAR_REMINDER', value: eventType.CALENDAR_REMINDER},

  {label: 'PATIENT_ADDED_BY_PRACTICE', value: eventType.PATIENT_ADDED_BY_PRACTICE},
  {label: 'PATIENT_ASSIGNED_TO_PRACTICE', value: eventType.PATIENT_ASSIGNED_TO_PRACTICE},
  {label: 'PRACTICE_CONNECTED_ORG', value: eventType.PRACTICE_CONNECTED_ORG},

  {label: 'NEW_ORDER_ADDED', value: eventType.NEW_ORDER_ADDED},
  {
    label: 'ORG_SEND_TREATMENT_PLAN_FOR_APPROVAL',
    value: eventType.ORG_SEND_TREATMENT_PLAN_FOR_APPROVAL,
  },
  {label: 'PLAN_FINALIZED_BY_PRACTICE', value: eventType.PLAN_FINALIZED_BY_PRACTICE},
  {label: 'ORDER_ON_HOLD', value: eventType.ORDER_ON_HOLD},
  {label: 'ORDER_CANCELLED', value: eventType.ORDER_CANCELLED},
  {label: 'RE_PLAN_TREATMENT', value: eventType.RE_PLAN_TREATMENT},

  {label: 'LAB_ADMIN_ASSIGN_ORDER', value: eventType.LAB_ADMIN_ASSIGN_ORDER},
  {
    label: 'THIRD_PARTY_CUSTOMER_REQUEST_STL_FILES',
    value: eventType.THIRD_PARTY_CUSTOMER_REQUEST_STL_FILES,
  },
  {
    label: 'THIRD_PARTY_CUSTOMER_REQUEST_RE_PLAN',
    value: eventType.THIRD_PARTY_CUSTOMER_REQUEST_RE_PLAN,
  },
  {label: 'THIRD_PARTY_CUSTOMER_SEND_CASE', value: eventType.THIRD_PARTY_CUSTOMER_SEND_CASE},
  {
    label: 'THIRD_PARTY_CUSTOMER_APPROVE_TREATMENT_PLAN',
    value: eventType.THIRD_PARTY_CUSTOMER_APPROVE_TREATMENT_PLAN,
  },
  {label: 'LAB_ADMIN_SEND_TREATMENT_PLAN', value: eventType.LAB_ADMIN_SEND_TREATMENT_PLAN},
  {label: 'LAB_ADMIN_SEND_STL_FILES', value: eventType.LAB_ADMIN_SEND_STL_FILES},

  {label: 'COMMENT_ADDED_ON_ORDER', value: eventType.COMMENT_ADDED_ON_ORDER},
  {label: 'INVITATION_REJECTED', value: eventType.INVITATION_REJECTED},
  {label: 'DOCTOR_INVITATION_RECEIVED', value: eventType.DOCTOR_INVITATION_RECEIVED},
  {label: 'STL_FILE_APPROVED', value: eventType.STL_FILE_APPROVED},
  {label: 'DOCTOR_INVITATION_REJECTED', value: 'DOCTOR_INVITATION_REJECTED'},
  {label: 'TREATMENT_STARTING_TOMORROW', value: 'TREATMENT_STARTING_TOMORROW'},

  {label: 'MANUFACTURING_IN_TRANSIT', value: eventType.MANUFACTURING_IN_TRANSIT},
  {label: 'MANUFACTURING_DELIVERED', value: eventType.MANUFACTURING_DELIVERED},
  {label: 'CASE_MOVED_TO_PLANNING', value: eventType.CASE_MOVED_TO_PLANNING},
  {label: 'CASE_MOVED_TO_PRODUCTION', value: eventType.CASE_MOVED_TO_PRODUCTION},
  {label: 'MANUFACTURING_COMPLETED', value: eventType.MANUFACTURING_COMPLETED},
  {label: 'CASE_READY_TO_BEGIN_TREATMENT', value: eventType.CASE_READY_TO_BEGIN_TREATMENT},
  {label: 'CASE_ASSIGNED_TO_YOU', value: eventType.CASE_ASSIGNED_TO_YOU},
  {label: 'NEW_COMMENT_ADDED', value: eventType.NEW_COMMENT_ADDED},
  {label: 'STATUS_UPDATED', value: eventType.STATUS_UPDATED},
  {label: 'RECORDS_ADDED', value: eventType.RECORDS_ADDED},
  {label: 'PRESCRIPTION_ADDED', value: eventType.PRESCRIPTION_ADDED},
  {label: 'PLANNING_CASE_COMPLETED', value: eventType.PLANNING_CASE_COMPLETED},
  {label: 'TREATMENT_PLAN_ADDED', value: eventType.TREATMENT_PLAN_ADDED},
  {label: 'NEED_MORE_INFO_REQUESTED', value: eventType.NEED_MORE_INFO_REQUESTED},
  {
    label: 'UPDATED_FROM_NEED_MORE_INFO_TO_ORDERED',
    value: eventType.UPDATED_FROM_NEED_MORE_INFO_TO_ORDERED,
  },
  {
    label: 'ORDER_CANCELLED',
    value: eventType.ORDER_CANCELLED,
  },
  {
    label: 'PLANNING_CUSTOMER_PATIENT_ONBOARDED',
    value: eventType.PLANNING_CUSTOMER_PATIENT_ONBOARDED,
  },
  {
    label: 'PLANNING_CUSTOMER_LAB_UPLOADED_STL_FILES',
    value: eventType.PLANNING_CUSTOMER_LAB_UPLOADED_STL_FILES,
  },
  {
    label: 'PLANNING_CUSTOMER_CASE_COMPLETED',
    value: eventType.PLANNING_CUSTOMER_CASE_COMPLETED,
  },
  {
    label: 'PLANNING_CUSTOMER_TREATMENT_PLAN_APPROVED',
    value: eventType.PLANNING_CUSTOMER_TREATMENT_PLAN_APPROVED,
  },
  {
    label: 'PLANNING_CUSTOMER_TREATMENT_PLAN_REVISION',
    value: eventType.PLANNING_CUSTOMER_TREATMENT_PLAN_REVISION,
  },
  {
    label: 'PLANNING_CUSTOMER_TREATMENT_PLAN_SENT_FOR_APPROVAL',
    value: eventType.PLANNING_CUSTOMER_TREATMENT_PLAN_SENT_FOR_APPROVAL,
  },
  {
    label: 'PLANNING_CUSTOMER_NEED_MORE_INFO_REQUESTED',
    value: eventType.PLANNING_CUSTOMER_NEED_MORE_INFO_REQUESTED,
  },
  {label: 'VSP_CASE_ASSIGNED', value: eventType.VSP_CASE_ASSIGNED},
  {label: 'VSP_CASE_SUBMITTED', value: eventType.VSP_CASE_SUBMITTED},
  {label: 'VSP_FILES_UPLOADED', value: eventType.VSP_FILES_UPLOADED},
  {label: 'VSP_PLAN_READY_FOR_REVIEW', value: eventType.VSP_PLAN_READY_FOR_REVIEW},
  {label: 'VSP_PLAN_APPROVED', value: eventType.VSP_PLAN_APPROVED},
  {label: 'VSP_REVISION_REQUESTED', value: eventType.VSP_REVISION_REQUESTED},
  {label: 'VSP_MORE_INFORMATION_REQUIRED', value: eventType.VSP_MORE_INFORMATION_REQUIRED},
  {label: 'VSP_PLANNING_COMPLETED', value: eventType.VSP_PLANNING_COMPLETED},
  {label: 'VSP_PRODUCTION_ORDER_CREATED', value: eventType.VSP_PRODUCTION_ORDER_CREATED},
  {label: 'VSP_ORDER_SHIPPED', value: eventType.VSP_ORDER_SHIPPED},
  {label: 'VSP_ORDER_DELIVERED', value: eventType.VSP_ORDER_DELIVERED},
  {
    label: 'VSP_NEW_MESSAGE_LAB_TO_CUSTOMER',
    value: eventType.VSP_NEW_MESSAGE_LAB_TO_CUSTOMER,
  },
  {
    label: 'VSP_NEW_MESSAGE_CUSTOMER_TO_LAB',
    value: eventType.VSP_NEW_MESSAGE_CUSTOMER_TO_LAB,
  },
]
